const PerPageDropDown = ({ setPerPage, setPage, perPage }: { setPerPage: React.Dispatch<React.SetStateAction<number>>; setPage: React.Dispatch<React.SetStateAction<number>>; perPage: number }) => {
  return (
    <select
      onChange={(e) => {
        const newPerPage = parseInt(e.target.value, 10);
        setPerPage(newPerPage);
        setPage(1);
      }}
      className='form-select border-none p-1 text-xs font-semibold text-[#475467] bg-[#fff] bg-clip-padding bg-no-repeat rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
      value={perPage}
    >
      {[4, 6, 9, 10, 12, 14].map((size) => (
        <option key={size} value={size}>
          {size} per page
        </option>
      ))}
    </select>
  );
};

export default PerPageDropDown;
